import { render, staticRenderFns } from "./About_section.vue?vue&type=template&id=5e341abe&scoped=true&"
import script from "./About_section.vue?vue&type=script&lang=js&"
export * from "./About_section.vue?vue&type=script&lang=js&"
import style0 from "./About_section.vue?vue&type=style&index=0&id=5e341abe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e341abe",
  null
  
)

export default component.exports